import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseService } from '../../services/base.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  languages = [
    { value: 'ua', name: 'Українська', icon: 'ua' },
    { value: 'en', name: 'English', icon: 'en' },
  ];
  linkLogin = environment.login_url;
  linkRegister = environment.registration_url;
  currentLanguage!: string;
  showBanner = false;

  headerLinks = [
    { title: 'main', link: '/', icon: 'dashboard' },
    { title: 'olx.title', link: '/olx', icon: 'storefront' },
    { title: 'auto-ria.title', link: '/auto-ria', icon: 'directions_car' },
    { title: 'dim-ria.title', link: '/dom-ria', icon: 'house' },
    { title: 'agro-ria.title', link: '/agro-ria', icon: 'agriculture' },
    { title: 'instagram.title', link: '/instagram', icon: 'photo_camera' },
    { title: 'telegram.title', link: '/telegram', icon: 'send' },
    { title: 'viber.title', link: '/viber', icon: 'chat' },
    { title: 'prom.title', link: '/prom', icon: 'chat' },
    { title: 'whatsApp.title', link: '/whatsapp', icon: 'chat' },
  ];

  constructor(
    private translate: TranslateService,
    public baseService: BaseService,
  ) {
  }

  ngOnInit() {
    this.initUtm();
    this.initLang();
    // this.showBanner = localStorage.getItem('price_banner_closed_v1') !== 'true';
  }

  closeBanner() {
    this.showBanner = false;
    localStorage.setItem('price_banner_closed_v1', 'true');
  }

  initUtm() {
    const utm = localStorage.getItem('utm_source');
    if (utm) {
      this.linkLogin = `${environment.login_url}?utm_source=${utm}`;
      this.linkRegister = `${environment.registration_url}?utm_source=${utm}`;
    }
  }

  initLang() {
    this.currentLanguage = localStorage.getItem('language') || 'ua';
  }

  scrollTo(id: string) {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }

  onChangeLanguage(lang: string) {
    this.translate.use(lang);
    this.currentLanguage = lang;
    localStorage.setItem('language', lang);
  }

  scrollTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  scrollSoon() {
    requestAnimationFrame(() => {
      const el = document.querySelector('#app-scroll') as HTMLElement;
      (el ?? window).scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

}
